(function () {
  var dialog = document.querySelector('[data-newsletter-popup]');
  if (!dialog || typeof dialog.showModal !== 'function') return;

  var DISMISS_KEY = 'bsPopupDismissedAt';
  var SUBSCRIBED_KEY = 'bsNewsletterSubscribed';
  var offerView = dialog.querySelector('[data-popup-view="offer"]');
  var successView = dialog.querySelector('[data-popup-view="success"]');
  var live = dialog.querySelector('[data-popup-live]');
  var form = dialog.querySelector('form');
  var delay = parseInt(dialog.getAttribute('data-delay'), 10) || 0;
  var days = parseInt(dialog.getAttribute('data-dismiss-days'), 10) || 30;
  var timer = null;
  var showingSuccess = false;
  var isDesignMode = !!(window.Shopify && window.Shopify.designMode);
  var downOnBackdrop = false;

  function read(store, key) {
    try {
      return window[store].getItem(key);
    } catch (e) {
      return null;
    }
  }

  // Instant Form leads arrive with utm_campaign=instant-form; they already gave their email.
  function fromInstantForm() {
    var pairs = (window.location.search || '').replace(/^\?/, '').split('&');
    for (var i = 0; i < pairs.length; i++) {
      var eq = pairs[i].indexOf('=');
      if (eq < 0) continue;
      try {
        if (decodeURIComponent(pairs[i].slice(0, eq)) === 'utm_campaign' &&
            decodeURIComponent(pairs[i].slice(eq + 1).replace(/\+/g, ' ')) === 'instant-form') return true;
      } catch (e) {}
    }
    return false;
  }

  function isSuppressed() {
    if (document.body.hasAttribute('data-no-signup-popup')) return true;
    if (fromInstantForm()) {
      try {
        localStorage.setItem(SUBSCRIBED_KEY, '1');
      } catch (e) {}
      return true;
    }
    if (read('localStorage', SUBSCRIBED_KEY)) return true;
    var at = parseInt(read('localStorage', DISMISS_KEY), 10);
    if (at && Date.now() - at < days * 86400000) return true;
    return false;
  }

  function setView(name) {
    showingSuccess = name === 'success';
    successView.hidden = !showingSuccess;
    offerView.hidden = showingSuccess;
  }

  function open() {
    if (dialog.open) return;
    dialog.showModal();
    document.documentElement.style.overflow = 'hidden';
    if (!showingSuccess && form) {
      var wide = !!(window.matchMedia && window.matchMedia('(min-width: 750px) and (pointer: fine)').matches);
      var field = wide
        ? form.querySelector('input[name="contact[email]"]')
        : offerView.querySelector('.newsletter-popup__heading');
      if (field) field.focus();
    }
  }

  function record() {
    try {
      localStorage.setItem(DISMISS_KEY, String(Date.now()));
    } catch (e) {}
  }

  dialog.addEventListener('close', function () {
    document.documentElement.style.overflow = '';
    if (!showingSuccess && !isDesignMode) record();
  });

  dialog.addEventListener('mousedown', function (event) {
    downOnBackdrop = event.target === dialog;
  });

  dialog.addEventListener('click', function (event) {
    var target = event.target;
    if (target === dialog) {
      if (downOnBackdrop) dialog.close();
      downOnBackdrop = false;
      return;
    }
    var closer = target.closest ? target.closest('[data-popup-close]') : null;
    if (closer) dialog.close();
  });

  var copyButtons = dialog.querySelectorAll('[data-popup-copy]');
  Array.prototype.forEach.call(copyButtons, function (button) {
    button.addEventListener('click', function () {
      var code = button.getAttribute('data-popup-copy');
      if (!navigator.clipboard || !navigator.clipboard.writeText) return;
      navigator.clipboard.writeText(code).then(function () {
        if (!live) return;
        live.textContent = '';
        window.setTimeout(function () {
          live.textContent = 'Copied';
        }, 50);
      }, function () {});
    });
  });

  function showAfterReload() {
    var hasErrors = form && form.querySelector('.newsletter-popup__error');
    if (window.bsNewsletterLastSource === 'popup') {
      setView('success');
      open();
      var heading = successView.querySelector('.newsletter-popup__heading');
      if (heading) heading.focus();
      return true;
    }
    if (hasErrors && read('sessionStorage', 'bsNewsletterSource') === 'popup') {
      setView('offer');
      open();
      var input = form.querySelector('input[name="contact[email]"]');
      if (input) input.focus();
      return true;
    }
    return false;
  }

  function schedule() {
    if (isSuppressed()) return;
    timer = window.setTimeout(open, delay * 1000);
  }

  function init() {
    if (showAfterReload()) return;
    if (window.Shopify && window.Shopify.designMode) return;
    schedule();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:select', function (event) {
      if (dialog.closest('.shopify-section') === event.target) {
        setView('offer');
        open();
      }
    });
    document.addEventListener('shopify:section:deselect', function (event) {
      if (dialog.closest('.shopify-section') === event.target && dialog.open) dialog.close();
    });
  }

  // Runs after the shared snippet's inline success script, which sets bsNewsletterLastSource.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
